import razorpayCheckout from './razorpayCheckout.js';
import paypalButtons from './paypalButtons.js';
import ccavenueIframe from './ccavenueIframe.js';
import hostedRedirect from './hostedRedirect.js';

/**
 * The browser-side mirror of the backend provider registry, for EMBEDDED flows —
 * the ones where the provider's own widget opens on our page.
 *
 * Adding a provider is one file plus one line here. The checkout page asks for a
 * widget by the `library` name the adapter declared and never names a provider
 * itself.
 */
const WIDGETS = {
  'razorpay-checkout': razorpayCheckout,
  'paypal-buttons': paypalButtons,
  'ccavenue-iframe': ccavenueIframe,
  // Not one provider's library: the session kind every HOSTED_REDIRECT adapter returns (redirectSession).
  redirect: hostedRedirect,
};

export function getWidget(library) {
  const widget = WIDGETS[library];
  if (!widget) {
    throw new Error('This payment method is not available right now. Please contact the merchant.');
  }
  return widget;
}

export const hasWidget = (library) => Boolean(WIDGETS[library]);
